import type { ReactNode } from "react";
import { Command as CommandPrimitive } from "cmdk";

export interface SelectListEmptyProps {
  loading: boolean;
  loadingText: string;
  emptyText: ReactNode;
}

/** The row shown when no option matches, reading as loading while results are still on their way. */
export const SelectListEmpty = ({ loading, loadingText, emptyText }: SelectListEmptyProps) => (
  <CommandPrimitive.Empty data-slot="select-empty" className="py-6 text-center text-sm text-muted-foreground">
    {loading ? loadingText : emptyText}
  </CommandPrimitive.Empty>
);
